import { Link } from 'react-router-dom';
import { useState } from 'react';

const faqData = [
  {
    question: '西瓜影院需要付费吗？',
    answer: '西瓜影院完全免费！所有电影、电视剧、综艺、动漫、纪录片等内容均可免费在线观看，无任何隐藏收费项目。无需注册会员，无需订阅付费，即点即看。',
  },
  {
    question: '观看视频需要下载播放器吗？',
    answer: '不需要！西瓜影院采用HTML5网页播放技术，支持所有主流浏览器直接播放。您只需要打开网页，点击想看的视频，即可流畅播放，无需安装任何插件或播放器。',
  },
  {
    question: '西瓜影院的画质如何？',
    answer: '我们提供最高1080P高清画质，大部分热播内容均支持高清模式。根据您的网络状况，系统会自动选择最佳画质，确保流畅不卡顿。部分最新大片更支持4K超清画质。',
  },
  {
    question: '支持手机和平板观看吗？',
    answer: '当然支持！西瓜影院采用响应式设计，完美适配手机、平板、电脑等各种设备。无论您是在通勤路上、还是在家休息，都能随时随地享受高清影视内容。',
  },
  {
    question: '内容会定期更新吗？',
    answer: '我们拥有专业的更新团队，每日更新最新电影、电视剧和综艺节目。热播剧集当天更新，热门大片第一时间上线，确保您不错过任何精彩内容。',
  },
  {
    question: '遇到播放问题怎么办？',
    answer: '如果您在观看过程中遇到任何问题，可以尝试刷新页面或切换播放线路。如问题依旧存在，欢迎通过"关于我们"页面的联系方式向我们反馈，我们会尽快为您解决。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于西瓜影院的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-100 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[300px] pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/about#contact"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200"
          >
            还有问题？联系我们
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqData.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        })}
      </script>
    </section>
  );
}